import { render } from "./MobileMenuOverlay.vue?vue&type=template&id=16aa3494&scoped=true"
import script from "./MobileMenuOverlay.vue?vue&type=script&lang=js"
export * from "./MobileMenuOverlay.vue?vue&type=script&lang=js"

import "./MobileMenuOverlay.vue?vue&type=style&index=0&id=16aa3494&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16aa3494"]])

export default __exports__